import { Service } from '@/types';

export const services: Service[] = [
  {
    title: "Full Stack Development",
    description: "End-to-end application development using modern technologies and best practices.",
    features: [
      "React/Angular frontends",
      ".NET Core backends",
      "Database design & optimization",
      "API development & integration"
    ]
  },
  {
    title: "LTI Solutions",
    description: "Expert integration of Learning Tools Interoperability for educational platforms.",
    features: [
      "Canvas integration",
      "Blackboard connectivity",
      "Custom LMS solutions",
      "OAuth implementation"
    ]
  },
  {
    title: "Cloud Architecture",
    description: "Scalable cloud solutions with containerization and orchestration.",
    features: [
      "Microservices architecture",
      "Kubernetes deployment",
      "Docker containerization",
      "Cloud migration strategies"
    ]
  },
  {
    title: "Technical Consulting",
    description: "Strategic guidance for complex technical challenges and system architecture.",
    features: [
      "Architecture review",
      "Performance optimization",
      "Security assessment",
      "Technology selection"
    ]
  }
];
